import { jsxs as u, jsx as o } from "react/jsx-runtime";
import { c as r } from "../index-Cu0xwYjD.js";
import * as i from "react";
import { ErrorContext as x } from "../Context/ErrorContext.js";
const l = "_textInputContainer_g24t2_1", C = "_textInputContainerWithError_g24t2_27", d = "_textInputContainerWithIcon_g24t2_31", m = "_textInputContainerDisabled_g24t2_35", _ = "_textInputIcon_g24t2_46", t = {
  textInputContainer: l,
  textInputContainerWithError: C,
  textInputContainerWithIcon: d,
  textInputContainerDisabled: m,
  textInputIcon: _
}, h = i.forwardRef(
  (s, a) => {
    const { icon: e, ...n } = s, { errors: p } = i.useContext(x), I = r(t.textInput, n.className), c = e ? /* @__PURE__ */ o("span", { className: t.textInputIcon, children: e }) : null;
    return /* @__PURE__ */ u(
      "div",
      {
        className: r(t.textInputContainer, {
          [t.textInputContainerDisabled]: n.disabled,
          [t.textInputContainerWithIcon]: !!e,
          [t.textInputContainerWithError]: p.length > 0
        }),
        children: [
          c,
          /* @__PURE__ */ o(
            "input",
            {
              ref: a,
              ...n,
              className: I,
              disabled: n.disabled
            }
          )
        ]
      }
    );
  }
);
h.displayName = "TextInput";
export {
  h as TextInput
};
